import { Box, Button, Typography } from '@mui/material'
import {
  Link,
} from 'react-router-dom';

const NotFoundPage = () => {
  return (
 <Box
    sx={{
      textAlign: 'center',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Typography variant="h4" color="red.main">
      404 - Page Not Found
    </Typography>
    <Typography variant="body1" mb={2}>
      The page you are looking for does not exist.
    </Typography>
    <Button component={Link} to="/" variant="contained" >
      Go to Home page
    </Button>
  </Box>
  )
}

export default NotFoundPage
